export const objectFormData = (form: FormData) => {
    // const object: any = Array.from(form.entries()).reduce((p: any, c: any) =>
    //     (c[1] ? { ...p, [c[0]]: c[1] } : p), {})
    const object: any = Array.from(form.entries()).reduce((p: any, c: any) =>
        ({ ...p, [c[0]]: c[1] }), {})

    return object
}